/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typography_EngineInputs */

const en_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typography Engine`)
};

const es_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor tipográfico`)
};

const fr_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur typographique`)
};

const de_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typografie-Engine`)
};

const ja_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイポグラフィエンジン`)
};

const zh_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排版引擎`)
};

const ar_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محرك الخطوط`)
};

const id_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesin Tipografi`)
};

const it_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motore Tipografico`)
};

const ru_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Движок типографики`)
};

const pt_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mecanismo de Tipografia`)
};

const ko_typography_engine = /** @type {(inputs: Typography_EngineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타이포그래피 엔진`)
};

/**
* | output |
* | --- |
* | "Typography Engine" |
*
* @param {Typography_EngineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const typography_engine = /** @type {((inputs?: Typography_EngineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typography_EngineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_typography_engine(inputs)
	if (locale === "es") return es_typography_engine(inputs)
	if (locale === "fr") return fr_typography_engine(inputs)
	if (locale === "de") return de_typography_engine(inputs)
	if (locale === "ja") return ja_typography_engine(inputs)
	if (locale === "zh") return zh_typography_engine(inputs)
	if (locale === "ar") return ar_typography_engine(inputs)
	if (locale === "id") return id_typography_engine(inputs)
	if (locale === "it") return it_typography_engine(inputs)
	if (locale === "ru") return ru_typography_engine(inputs)
	if (locale === "pt") return pt_typography_engine(inputs)
	return ko_typography_engine(inputs)
});